import type { GaClientType, ObserverClientReturn } from '../types';

const GA_TRACK_EVENT = 'tracking-event';

class GaClient implements GaClientType {
  observerClient: ObserverClientReturn;

  constructor(observerClient: ObserverClientReturn) {
    this.observerClient = observerClient;
  }

  track = (category: string, action: string, label: string) => {
    const event = {
      ga: [
        {
          category,
          action,
          label,
        },
      ],
    };
    this.observerClient.track(GA_TRACK_EVENT, event);
  };
}

export default GaClient;
